import { render, staticRenderFns } from "./BbppModeloBancaActiva.vue?vue&type=template&id=55436d04"
import script from "./BbppModeloBancaActiva.vue?vue&type=script&lang=js"
export * from "./BbppModeloBancaActiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports